import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useState } from "react";
import "../../../CommonScss/QuotePage.scss";
import CustomButton from "../../../Components/Common/CustomButton/CustomButton";
import DatePicker from "../../../Components/Common/FieldTypes/DatePicker/DatePicker";
import RKTextField from "../../../Components/Common/FieldTypes/RKTextField/RKTextField";
import SelectDropdown from "../../../Components/Common/FieldTypes/SelectDropdown/SelectDropdown";
import GreyBoxTitle from "../../../Components/Desktop/GreyBoxTitle/GreyBoxTitle";
import QuoteNavbar from "../../../Components/Desktop/QuoteNavbar/QuoteNavbar";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../../shared/Path";

function TravellerDetails() {
  const navigate = useNavigate();
  const [formFields, setFormFields] = useState<{
    fullName: { value: string; warning: boolean };
    gender: { value: string; warning: boolean };
    ProposerDob: { value: Date | null; warning: boolean };
    relationshipwithProposer: { value: Date | null; warning: boolean };
    mobile: { value: string; warning: boolean };
    email: { value: string; warning: boolean };
  }>({
    fullName: { value: "", warning: false },
    gender: { value: "", warning: false },
    ProposerDob: { value: null, warning: false },
    relationshipwithProposer: { value: null, warning: false },
    mobile: { value: "", warning: false },
    email: { value: "", warning: false },
  });

  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName[3]({
      ...attrName[2],
      [attrName[0]]: { ...[attrName[0]], [attrName[1]]: value },
    });
  };

  return (
    <Box className="quoteWrapper">
      <QuoteNavbar />
      <Grid container spacing={3}>
        <Grid xs maxWidth="300px">
          <div className="ctaBtn mb-4">
            <CustomButton
              class_name="backBtn"
              text_name="Back"
              onClickFunction={() => {
                navigate(-1);
              }}
            />
          </div>
          <Box className="lefSidebar">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <div>
                <p>Travellers:</p>
                <h6>4 Members</h6>
              </div>
              <div>
                <p>Travelling to:</p>
                <h6>England, Canada</h6>
              </div>
              <div>
                <p>Departure on:</p>
                <h6>Dec 6, 2023</h6>
              </div>
              <div>
                <p>Return on:</p>
                <h6>Dec 26, 2023</h6>
              </div>
            </div>
            <Box className="whiteBox">
              <p
                style={{
                  borderBottom: "1px solid #6458D8",
                  marginBottom: "12px",
                }}
              >
                Worldwide Travel Policy
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <h5
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#6458D8",
                  }}
                >
                  ₹ 1,024
                </h5>
                <p>+ Taxes</p>
              </div>
            </Box>
          </Box>
        </Grid>
        <Grid xs>
          <>
            <Grid container spacing={3}>
              <Grid xs={12}>
                <GreyBoxTitle title="Traveller 1 Details" />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Full Name"}
                  value={formFields.fullName.value}
                  attrName={["fullName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.fullName.warning}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Gender"
                  value={formFields.gender.value}
                  attrName={["gender", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  dropdown_data={gender_data}
                  warn_status={formFields.gender.warning}
                />
              </Grid>
              <Grid xs={4}>
                <DatePicker
                  class_name="inputField datepicker"
                  title={"DOB"}
                  value={formFields.ProposerDob.value}
                  attrName={["ProposerDob", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  error_message=""
                  warn_status={formFields.ProposerDob.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Relationship with Proposer"}
                  value={formFields.relationshipwithProposer.value}
                  attrName={[
                    "relationshipwithProposer",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.relationshipwithProposer.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Mobile"}
                  value={formFields.mobile.value}
                  attrName={["mobile", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.mobile.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Email"}
                  value={formFields.email.value}
                  attrName={["email", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.email.warning}
                />
              </Grid>
            </Grid>

            {/* Traveller 2 Details */}
            <Grid container spacing={3}>
              <Grid xs={12}>
                <GreyBoxTitle title="Traveller 2 Details" />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Full Name"}
                  value={formFields.fullName.value}
                  attrName={["fullName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.fullName.warning}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Gender"
                  value={formFields.gender.value}
                  attrName={["gender", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  dropdown_data={gender_data}
                  warn_status={formFields.gender.warning}
                />
              </Grid>
              <Grid xs={4}>
                <DatePicker
                  class_name="inputField datepicker"
                  title={"DOB"}
                  value={formFields.ProposerDob.value}
                  attrName={["ProposerDob", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  error_message=""
                  warn_status={formFields.ProposerDob.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Relationship with Proposer"}
                  value={formFields.relationshipwithProposer.value}
                  attrName={[
                    "relationshipwithProposer",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.relationshipwithProposer.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Mobile"}
                  value={formFields.mobile.value}
                  attrName={["mobile", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.mobile.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Email"}
                  value={formFields.email.value}
                  attrName={["email", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.email.warning}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn text-center">
                <CustomButton
                  onClickFunction={() => {
                    navigate(PATH.NOMINEE_DETAILS);
                  }}
                  text_name="Continue"
                  class_name="blueXlBtn"
                />
              </Grid>
            </Grid>
          </>
        </Grid>
      </Grid>
    </Box>
  );
}

export default TravellerDetails;
